import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { StarInput } from "@/components/StarRating";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ReviewDialog({ open, onOpenChange, onSubmitted }) {
  const [stars, setStars] = useState(5);
  const [dept, setDept] = useState("");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (text.trim().length < 8) return toast.error("Please write a few words about your experience.");
    setLoading(true);
    try {
      await api.post("/testimonials", { stars, dept, text });
      toast.success("Thanks! Your review is now live.");
      onOpenChange(false);
      setText(""); setDept(""); setStars(5);
      onSubmitted && onSubmitted();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail, "Could not submit review"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="review-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Share your experience</DialogTitle></DialogHeader>
        <div className="flex flex-col items-center gap-2 py-2">
          <StarInput value={stars} onChange={setStars} />
          <span className="text-sm text-slate-500">{stars} out of 5 stars</span>
        </div>
        <div className="space-y-1.5">
          <Label>Year & Department <span className="text-slate-400 font-normal">(optional)</span></Label>
          <Input value={dept} onChange={(e) => setDept(e.target.value)} placeholder="e.g. B.Tech CSE · 3rd Year" data-testid="review-dept-input" />
        </div>
        <div className="space-y-1.5">
          <Label>Your review</Label>
          <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="How was the product quality and your experience on ReKTR?" data-testid="review-text-input" />
        </div>
        <Button onClick={submit} disabled={loading} className="w-full bg-brand hover:bg-brand-700 text-white h-11" data-testid="review-submit-btn">
          {loading ? <Loader2 className="animate-spin" size={18} /> : "Post review"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
